<template>
    <div>
        <b-row>
            <b-col cols="10">
                <b-row>
                    <b-col cols="4">
                        <b-form-input
                            type="text"
                            placeholder="Código de socio"
                            v-model="search.memberCode"></b-form-input>
                    </b-col>

                    <b-col cols="8">
                        <month-and-year-selector v-model="search.issueDate"></month-and-year-selector>
                    </b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col cols="4">
                        <periodicity-months-selector
                            v-model="search.periodicityMonths"
                            :allowEmpty="true"></periodicity-months-selector>
                    </b-col>

                    <b-col cols="4">
                        <payment-method-selector
                            v-model="search.paymentMethodName"
                            :allowEmpty="true"></payment-method-selector>
                    </b-col>

                    <b-col cols="4">
                        <receipt-member-called-selector
                            v-model="search.memberCalled"
                            :allowEmpty="true"></receipt-member-called-selector>
                    </b-col>
                </b-row>
            </b-col>

            <b-col cols="2">
                <div class="d-flex flex-row-reverse">
                    <button
                        class="btn btn-pill btn-primary px-4"
                        @click="refreshTable">
                        Buscar
                    </button>
                </div>
            </b-col>
        </b-row>

        <template v-if="showTables">

            <b-row class="mt-4">
                <b-col>
                    <b>Recibo Disponibles</b>
                </b-col>
            </b-row>

            <hr class="my-0">

            <b-row>
                <b-col class="my-2">
                    Acciones por lotes:
                    <button
                        class="btn btn-brand btn-primary btn-sm ml-2"
                        :disabled="checkedReceipts.length<1"
                        @click="copyCheckedToSelected">
                        Añadir
                    </button>
                    <button
                        class="btn btn-brand btn-primary btn-sm ml-2"
                        :disabled="checkedReceipts.length<1"
                        @click="printCheckedReceipts">
                        Imprimir
                    </button>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <v-server-table
                        ref="receiptsTable"
                        class="dataTable"
                        md="12"
                        lg="12"
                        sm="12"
                        :columns="columns"
                        :options="receiptOptions"
                        :theme="theme"
                        @loading="tableLoading"
                        @loaded="tableLoaded">
                        <template slot="beforeBody">
                            <tr v-if="loading">
                                <td class="text-center loading" colspan="7"><spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner></td>
                            </tr>
                        </template>
                        <template slot="check" slot-scope="props">
                            <b-form-checkbox
                                v-model="checkedReceipts"
                                :value="props.row"
                                class="m-0"></b-form-checkbox>
                        </template>

                        <template slot="member" slot-scope="props">
                            {{props.row.member.code}}
                        </template>

                        <template slot="amount" slot-scope="props">
                            {{props.row.amount}}€
                        </template>

                        <template slot="periodicity" slot-scope="props">
                            {{props.row.getPeriodicityName()}}
                        </template>

                        <template slot="status" slot-scope="props">
                            {{props.row.getStatusName()}}
                            <span v-if="props.row.memberCalled===true">
                                tras llamada
                            </span>
                            <span v-else-if="props.row.memberCalled===false">
                                sin llamar
                            </span>
                            <span v-if="!!props.row.chargeFromDate">
                                a partir del {{props.row.chargeFromDate | dateFormat('DD/MM/YYYY')}}
                            </span>
                        </template>

                        <template slot="actions" slot-scope="props">
                            <i
                                v-if="!receiptIsSelected(props.row)"
                                v-b-tooltip.hover.top
                                title="Añadir"
                                class="fa fa-plus pointer"
                                @click="copyToSelected(props.row)"></i>
                            <i
                                v-else
                                v-b-tooltip.hover.top
                                title="Eliminar"
                                class="fa fa-minus pointer"
                                @click="removeFromSelected(props.row)"></i>
                            <i
                                v-if="mixinCheckPermission('RECEIPT_PRINT')"
                                v-b-tooltip.hover.top
                                title="Imprimir"
                                class="fa fa-file ml-2 pointer"
                                @click="printReceipt(props.row.uuid)"></i>
                            <i
                                v-if="!!props.row.chargeFromDate && presentationDate < props.row.chargeFromDate"
                                v-b-tooltip.hover.top
                                title="La fecha de cobro es posterior a la fecha de presentación"
                                class="fa fa-warning ml-2"></i>
                        </template>
                    </v-server-table>
                </b-col>
            </b-row>

            <b-row class="mt-2">
                <b-col>
                    <b>Recibo Seleccionados</b>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <v-client-table
                        ref="selectedTable"
                        class="dataTable"
                        md="12"
                        lg="12"
                        sm="12"
                        :columns="columns"
                        :data="selectedReceipts"
                        :options="selectedOptions"
                        :theme="theme">
                        <template slot="check" slot-scope="props">
                            <span>&nbsp</span>
                        </template>

                        <template slot="member" slot-scope="props">
                            {{props.row.member.code}}
                        </template>

                        <template slot="amount" slot-scope="props">
                            {{props.row.amount}}€
                        </template>

                        <template slot="periodicity" slot-scope="props">
                            {{props.row.getPeriodicityName()}}
                        </template>

                        <template slot="status" slot-scope="props">
                            {{props.row.getStatusName()}}
                            <span v-if="props.row.memberCalled===true">
                                tras llamada
                            </span>
                            <span v-else-if="props.row.memberCalled===false">
                                sin llamar
                            </span>
                            <span v-if="!!props.row.chargeFromDate">
                                a partir del {{props.row.chargeFromDate | dateFormat('DD/MM/YYYY')}}
                            </span>
                        </template>

                        <template slot="actions" slot-scope="props">
                            <i
                                v-b-tooltip.hover.top
                                title="Eliminar"
                                class="fa fa-minus pointer"
                                @click="removeFromSelected(props.row)"></i>
                        </template>
                    </v-client-table>
                </b-col>
            </b-row>

            <div slot="footer" class="d-flex justify-content-end">
                <div>Importe Seleccionado: {{selectedAmount}} €</div>
                <div class="ml-2">
                    <button
                        class="btn btn-brand btn-primary btn-md"
                        :disabled="selectedReceipts.length<1"
                        @click="addSelectedReceiptsToConsignment()">
                        Añadir
                    </button>
                </div>
            </div>
        </template>

        <b-modal
            ref="printReceiptsModal"
            hide-footer
            size="sm"
            title="Imprimir Recibos"
            class="text-center"
            @hidden="printReceiptsModalClosed">
            <b-row>
                <b-col class="text-left">
                    <b-form-checkbox
                        type="checkbox"
                        stacked
                        v-model="print.useExpeditionDate"
                        name="hide">Especificar fecha de expedición
                    </b-form-checkbox>
                </b-col>
            </b-row>

            <b-row v-if="!!print.useExpeditionDate" class="mt-3">
                <b-col>
                    <v-date-picker
                        class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                        v-model="print.expeditionDate">
                    </v-date-picker>
                </b-col>
            </b-row>

            <b-row v-if="print.receiptsIds.length>=1" class="mt-3">
                <b-col class="d-flex flex-row-reverse">
                    <button
                        class="btn btn-brand btn-primary btn-lg"
                        :disabled="!!print.useExpeditionDate && !print.expeditionDate"
                        @click="printReceipts(print.receiptsIds, print.expeditionDate)">
                        Imprimir
                    </button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {ServerTable} from 'vue-tables-2';
    import form from '@/helpers/form';
    import {getReceipts, printReceipts} from '@/api/receipt-api';
    import {addReceiptsToConsignment} from '@/api/consignment-api';
    import monthAndYearSelector from '@/components/MonthAndYearSelector'
    import paymentMethodSelector from '@/components/clients/members/PaymentMethodSelector';
    import periodicityMonthsSelector from '@/components/periodicity/PeriodicityMonthsSelector';
    import receiptMemberCalledSelector from '@/components/consignments/receipts/ReceiptMemberCalledSelector';
    import Spinner from 'vue-simple-spinner';

    Vue.use(ServerTable);

    export default {
        name: "AddReceiptsToReturnConsignment",
        components: {
            monthAndYearSelector,
            paymentMethodSelector,
            periodicityMonthsSelector,
            receiptMemberCalledSelector,
            Spinner
        },
        props: {
            value: Object,
            headquartersId: String,
            presentationDate: Date
        },
        data() {
            return {
                columns: ['check', 'code', 'member', 'periodicity', 'amount', 'status', 'actions'],
                loading: true,
                receiptOptions: {
                    headings: {
                        check: '',
                        code: 'Recibo',
                        member: 'Socio',
                        periodicity: 'Cuota',
                        amount: 'Importe',
                        status: 'Tratamiento',
                        actions: ''
                    },
                    columnsClasses: {
                        check: "fit",
                        actions: "fit"
                    },
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    sortable: [],
                    filterable: [],
                    texts: null,
                    pagination: {
                        chunk: 10,
                        edge: true,
                        nav: 'scroll'
                    },
                    rowClassCallback: (row) => this.getRowClass(row),
                    requestFunction: (data) => {
                        this.search.page = data.page;
                        this.search.itemsPerPage = data.limit;
                        return getReceipts(this.searchData);
                    },
                    responseAdapter: (data) => {
                        return {
                            data: data.receipts,
                            count: data.count
                        }
                    },
                },
                selectedOptions: {
                    headings: {
                        check: '',
                        code: 'Recibo',
                        member: 'Socio',
                        periodicity: 'Cuota',
                        amount: 'Importe',
                        status: 'Tratamiento',
                        actions: ''
                    },
                    columnsClasses: {
                        check: "fit",
                        actions: "fit"
                    },
                    sortable: [],
                    filterable: [],
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    texts: null,
                    pagination: {
                        chunk: 10,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                theme: 'bootstrap4',
                search: {
                    page: 1,
                    itemsPerPage: 100,
                    memberCode: null,
                    issueDate: null,
                    periodicityMonths: null,
                    paymentMethodName: null,
                    memberCalled: null
                },
                showTables: false,
                checkedReceipts: [],
                selectedReceipts: [],
                print: {
                    receiptsIds: [],
                    useExpeditionDate: false,
                    expeditionDate: null
                }
            }
        },
        computed: {
            searchData() {
                let data = {
                    page: this.search.page,
                    itemsPerPage: this.search.itemsPerPage,
                    headquartersId: this.headquartersId,
                    status: 'CHARGE_BY_BANK'
                };

                if (!!this.search.memberCode) {
                    data['memberCode'] = this.search.memberCode;
                }
                if (!!this.search.issueDate) {
                    data['issueDate'] = this.search.issueDate.toISOString();
                }
                if (!!this.search.periodicityMonths) {
                    data['periodicityMonths'] = this.search.periodicityMonths;
                }
                if (!!this.search.paymentMethodName) {
                    data['paymentMethodName'] = this.search.paymentMethodName;
                }
                if (this.search.memberCalled !== null) {
                    data['memberCalled'] = this.search.memberCalled;
                }

                return data;
            },
            selectedAmount() {
                return this.selectedReceipts.reduce(function (accumulator, receipt) {
                    return accumulator + receipt.amount;
                }, 0);

            }
        },
        created() {
            this.receiptOptions.texts = form.tableLabels();
            this.selectedOptions.texts = form.tableLabels();
        },
        methods: {
            getRowClass: function (receipt) {
                return this.receiptIsSelected(receipt) ? 'selected-receipt' : '';
            },
            tableLoading(data) {
                this.checkedReceipts = [];
                this.$_loadingMixin_showLoading();
                this.loading = true;
                this.$refs.receiptsTable.data = [];
                if (!!document.querySelector('.VueTables__no-results')) {
                    document.querySelector('.VueTables__no-results').style.display = 'none';
                }
            },
            tableLoaded(data) {
                this.$_loadingMixin_hideLoading();
                this.loading = false;
                if (!!document.querySelector('.VueTables__no-results')) {
                    document.querySelector('.VueTables__no-results').style.display = 'table-row';
                }
            },
            refreshTable() {
                if (this.showTables) {
                    this.$refs.receiptsTable.refresh();
                } else {
                    this.showTables = true;
                }
            },
            copyToSelected(receipt) {
                if (!this.receiptIsSelected(receipt)) {
                    this.selectedReceipts.push(receipt);
                }
            },
            copyCheckedToSelected() {
                this.checkedReceipts.forEach(receipt => {
                    this.copyToSelected(receipt);
                });
            },
            removeFromSelected(receipt) {
                this.selectedReceipts = this.selectedReceipts.filter(selectedReceipt => (
                    receipt.uuid !== selectedReceipt.uuid
                ));
            },
            receiptIsSelected(receipt) {
                return !!this.selectedReceipts.find(selectedReceipts => (selectedReceipts.uuid === receipt.uuid));
            },
            async addSelectedReceiptsToConsignment() {
                this.$_loadingMixin_showLoading();
                await addReceiptsToConsignment(this.value.uuid, this.selectedReceipts.map(receipt => (receipt.uuid)))
                    .then((consignment) => {
                        this.selectedReceipts = [];
                        this.showTables = false;
                        this.$_notificationMixin_success('Operación completada', 'Los recibos se han añadido a la remesa');
                        this.$emit('input', consignment);
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Error en la operación', 'No se han podido añadir los recibos');
                    });
                this.$_loadingMixin_hideLoading();
            },
            async printReceipts(receiptsIds, expeditionDate) {
                this.$_loadingMixin_showLoading();
                let date = !!expeditionDate ? expeditionDate.toISOString() : null;
                await printReceipts(receiptsIds, date)
                    .then((dataStream) => {
                        const file = new Blob([dataStream]);
                        const fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    })
                    .catch(() => {
                        this.$_notificationMixin_error("Se ha producido un error", "No hemos podido recuperar la previsualización del documento");
                    });
                this.$_loadingMixin_hideLoading();
            },
            openPrintReceiptsModal() {
                this.$refs.printReceiptsModal.show();
            },
            printReceiptsModalClosed() {
                this.print.receiptsIds = [];
                this.print.useExpeditionDate = false;
                this.print.expeditionDate = null;
            },
            printReceipt(uuid) {
                this.print.receiptsIds = [];
                this.print.receiptsIds.push(uuid);
                this.openPrintReceiptsModal();
            },
            printCheckedReceipts() {
                this.print.receiptsIds = this.checkedReceipts.map(receipt => (receipt.uuid));
                this.openPrintReceiptsModal();
            }
        }
    }
</script>

<style lang="scss">
    .pointer {
        cursor: pointer;
    }

    .selected-receipt {
        background-color: lightgreen !important;
    }

    .VueTables__no-results {
        display: none;
    }
</style>